import React, { useState, useEffect } from 'react';
import { useCustomers } from '../../hooks/useCustomers';
import CustomerMatchWarning from './CustomerMatchWarning';
import { noAutofill } from '../../utils/noAutofill';

export default function CustomerSection({ formData, onChange }) {
  const { searchCustomers } = useCustomers();
  const [potentialMatches, setPotentialMatches] = useState([]);
  const [showWarning, setShowWarning] = useState(false);

  // Debounced search for duplicate customers
  useEffect(() => {
    const timer = setTimeout(async () => {
      if (formData.customerName && formData.customerName.length >= 3) {
        const matches = await searchCustomers(formData.customerName);
        if (matches.length > 0) {
          setPotentialMatches(matches);
          setShowWarning(true);
        }
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [formData.customerName, searchCustomers]);

  function handleSelectExistingCustomer(customer) {
    onChange({
      customerId: customer.id,
      customerName: customer.name,
      phoneNumber: customer.phone || '',
      customerEmail: customer.email || '',
      address: customer.address || ''
    });
    setShowWarning(false);
  }

  function handleIgnoreWarning() {
    setShowWarning(false);
  }

  return (
    <div>
      <h3 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: 'var(--text-primary)',
        marginBottom: '16px'
      }}>
        Customer Information
      </h3>

      {showWarning && (
        <CustomerMatchWarning
          matches={potentialMatches}
          onSelect={handleSelectExistingCustomer}
          onIgnore={handleIgnoreWarning}
        />
      )}

      {/* Customer Name */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '6px'
        }}>
          Customer Name *
        </label>
        <input
          type="text"
          value={formData.customerName || ''}
          onChange={(e) => onChange({ customerName: e.target.value })}
          placeholder="John Doe"
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--brand-brown)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--input-border)'}
          {...noAutofill}
        />
      </div>

      {/* Phone Number */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '6px'
        }}>
          Phone Number
        </label>
        <input
          type="tel"
          value={formData.phoneNumber || ''}
          onChange={(e) => onChange({ phoneNumber: e.target.value })}
          placeholder="(605) 123-4567"
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--brand-brown)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--input-border)'}
          {...noAutofill}
        />
      </div>

      {/* Email */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '6px'
        }}>
          Email
        </label>
        <input
          type="email"
          value={formData.customerEmail || ''}
          onChange={(e) => onChange({ customerEmail: e.target.value })}
          placeholder="john@example.com"
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--brand-brown)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--input-border)'}
          {...noAutofill}
        />
      </div>

      {/* Address */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '6px'
        }}>
          Address
        </label>
        <input
          type="text"
          value={formData.address || ''}
          onChange={(e) => onChange({ address: e.target.value })}
          placeholder="123 Main St, Milbank, SD 57252"
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--brand-brown)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--input-border)'}
          {...noAutofill}
        />
      </div>
    </div>
  );
}